// extracted by mini-css-extract-plugin
export default {"modalFooter":"webpack-concepts-Extraction-FormBuilder-ResetAllWarningDialog-module__modalFooter"};